import * as types from "../../actionType";
import Cookies from "js-cookie";
import { toast } from "../../../UIComponents/Toast";
import { client } from "../../AxiosInterceptor";
import { useSelector } from "react-redux";
import { filter } from "jszip";

export const savecloseToggle = (payload) => ({
  type: types.SAVE_CLOSE_TOGGLE,
  payload,
});
export const resetSeasonFilter = (payload) => ({
  type: types.RESET_SEASON_FILTER,
  payload,
});
export const resetSrtSeasonFilter = (payload) => ({
  type: types.RESET_SRT_SEASON_FILTER,
  payload,
});
export const resetSrtData = (payload) => ({
  type: types.RESET_SRT_DATA,
  payload,
});
export const resetMassFilter = (payload) => ({
  type: types.RESET_MASS_FILTER,
  payload,
});
export const resetMassUnsolicitedFilter = (payload) => ({
  type: types.RESET_MASS_UNSOLICITED_FILTER,
  payload,
});
export const ExFactoryDateVariable = (payload) => ({
  type: types.EXFACTORY_DATE,
  payload,
});
export const reqRecDate = (payload) => ({
  type: types.REQ_REC_DATE,
  payload,
});
export const srtbrandName = (payload) => ({
  type: types.SRT_BRANDS,
  payload,
});
export const srtSeasonName = (payload) => ({
  type: types.SRT_SEASONS,
  payload,
});
export const srtRowIndexForAutoScroll = (payload) => ({
  type: types.ROW_INDEX_FOR_AUTOSCROLL,
  payload,
});
export const srtEXportArray = (payload) => ({
  type: types.SRT_EXPORT_DATA,
  payload,
});
export const selectUnselectSrtTableRows = (payload) => ({
  type: types.SELECT_UNSELECT_SRT_TABLE_ROWS,
  payload,
});
export const clearDateOnSubmit = (payload) => ({
  type: types.CLEAR_DATE_ON_BTN_CLICK,
  payload,
});
// const brandName = useSelector((state) => state.srt.srtBrandNames);

const getSrtListLoading = () => ({
  type: types.GET_SRT_LIST_LOADING,
});
const getSrtListSuccess = (data) => ({
  type: types.GET_SRT_LIST_SUCCESS,
  payload: data,
});
const getSrtListFail = (error) => ({
  type: types.GET_SRT_LIST_FAIL,
  payload: error,
});
const massSearchFilterLoading = () => ({
  type: types.MASS_SEARCH_FILTER_LOADING,
});
const massSearchFilterSuccess = (payload) => ({
  type: types.MASS_SEARCH_FILTER_SUCCESS,
  payload,
});
const massSearchFilterFail = (error) => ({
  type: types.MASS_SEARCH_FILTER_FAIL,
  payload: error,
});
const unsolicitedMassSearchFilterLoading = () => ({
  type: types.UNSOLICITED_MASS_SEARCH_FILTER_LOADING,
});
const unsolicitedMassSearchFilterSuccess = (payload) => ({
  type: types.UNSOLICITED_MASS_SEARCH_FILTER_SUCCESS,
  payload,
});
const unsolicitedMassSearchFilterFail = (error) => ({
  type: types.UNSOLICITED_MASS_SEARCH_FILTER_FAIL,
  payload: error,
});
const seasonSearchFilterLoading = () => ({
  type: types.SEASON_SEARCH_FILTER_LOADING,
});
const seasonSearchFilterSuccess = (payload) => ({
  type: types.SEASON_SEARCH_FILTER_SUCCESS,
  payload,
});
const seasonSearchFilterFail = (error) => ({
  type: types.SEASON_SEARCH_FILTER_FAIL,
  payload: error,
});
const brandCommentSaverLoading = () => ({
  type: types.BRAND_COMMENT_SAVER_LOADING,
});
const brandCommentSaverSuccess = (payload) => ({
  type: types.BRAND_COMMENT_SAVER_SUCCESS,
  payload,
});
const brandCommentSaverFail = (error) => ({
  type: types.BRAND_COMMENT_SAVER_FAIL,
  payload: error,
});
const designStatusSaverLoading = () => ({
  type: types.DESIGN_STATUS_SAVER_LOADING,
});
const designStatusSaverSuccess = (payload) => ({
  type: types.DESIGN_STATUS_SAVER_SUCCESS,
  payload,
});
const designStatusSaverFail = (error) => ({
  type: types.DESIGN_STATUS_SAVER_FAIL,
  payload: error,
});
const srtDataSaverLoading = () => ({
  type: types.SRT_DATA_SAVE_LOADING,
});
const srtDataSaverSuccess = (payload) => ({
  type: types.SRT_DATA_SAVE_SUCCESS,
  payload,
});
const srtDataSaverFail = (error) => ({
  type: types.SRT_DATA_SAVE_FAIL,
  payload: error,
});
const srtExportLoading = () => ({
  type: types.SRT_EXPORT_LOADING,
});
const srtExportSuccess = (payload) => ({
  type: types.SRT_EXPORT_SUCCESS,
  payload,
});
const srtExportFail = (error) => ({
  type: types.SRT_EXPORT_FAIL,
  payload: error,
});
const srtUnsolicitedExportLoading = () => ({
  type: types.SRT_UNSOLICITED_EXPORT_LOADING,
});
const srtUnsolicitedExportSuccess = (payload) => ({
  type: types.SRT_UNSOLICITED_EXPORT_SUCCESS,
  payload,
});
const srtUnsolicitedExportFail = (error) => ({
  type: types.SRT_UNSOLICITED_EXPORT_FAIL,
  payload: error,
});
const srtReportGenerationLoading = () => ({
  type: types.SRT_REPORT_GENERATION_LOADING,
});
const srtReportGenerationSuccess = (payload) => ({
  type: types.SRT_REPORT_GENERATION_SUCCESS,
  payload,
});
const srtReportGenerationFail = (error) => ({
  type: types.SRT_REPORT_GENERATION_FAIL,
  payload: error,
});
const srtCommentUpdateLoading = () => ({
  type: types.SRT_COMMENT_UPDATE_LOADING,
});
const srtCommentUpdateSucces = (payload) => ({
  type: types.SRT_COMMENT_UPDATE_SUCCESS,
  payload,
});
const srtCommentUpdateFail = (error) => ({
  type: types.SRT_COMMENT_UPDATE_FAIL,
  payload: error,
});
const srtLogsLoading = () => ({
  type: types.SRT_LOGS_LOADING,
});
const srtLogsSuccess = (payload) => ({
  type: types.SRT_LOGS_SUCCESS,
  payload,
});
const srtLogsFail = (error) => ({
  type: types.SRT_LOGS_FAIL,
  payload: error,
});
const srtSeasonSearchFilterLoading = () => ({
  type: types.SRT_SEASON_SEARCH_FILTER_LOADING,
});
const srtSeasonSearchFilterSuccess = (payload) => ({
  type: types.SRT_SEASON_SEARCH_FILTER_SUCCESS,
  payload,
});
const srtSeasonSearchFilterFail = (error) => ({
  type: types.SRT_SEASON_SEARCH_FILTER_FAIL,
  payload: error,
});
const srtBulkSaveLoading = () => ({
  type: types.SRT_BULK_SAVE_LOADING,
});
const srtBulkSaveSuccess = (payload) => ({
  type: types.SRT_BULK_SAVE_SUCCESS,
  payload,
});
const srtBulkSaveFail = (error) => ({
  type: types.SRT_BULK_SAVE_FAIL,
  payload: error,
});
const getSrtUnsolicitedListLoading = () => ({
  type: types.GET_SRT_UNSOLICITED_LIST_LOADING,
});
const getSrtUnsolicitedListSuccess = (data) => ({
  type: types.GET_SRT_UNSOLICITED_LIST_SUCCESS,
  payload: data,
});
const getSrtUnsolicitedListFail = (error) => ({
  type: types.GET_SRT_UNSOLICITED_LIST_FAIL,
  payload: error,
});
const srtUnsolicitedBulkUploadLoading = () => ({
  type: types.SRT_UNSOLICITED_BULK_UPLOAD_LOADING,
});
const srtUnsolicitedBulkUploadSuccess = (payload) => ({
  type: types.SRT_UNSOLICITED_BULK_UPLOAD_SUCCESS,
  payload,
});
const srtUnsolicitedBulkUploadFail = (error) => ({
  type: types.SRT_UNSOLICITED_BULK_UPLOAD_FAIL,
  payload: error,
});
const srtUnsolicitedEditLoading = () => ({
  type: types.SRT_UNSOLICITED_EDIT_LOADING,
});
const srtUnsolicitedEditSuccess = (payload) => ({
  type: types.SRT_UNSOLICITED_EDIT_SUCCESS,
  payload,
});
const srtUnsolicitedEditFail = (error) => ({
  type: types.SRT_UNSOLICITED_EDIT_FAIL,
  payload: error,
});
const UnsolicitedListLoading = () => ({
  type: types.UNSOLICITED_LIST_LOADING,
});
const UnsolicitedListSuccess = (payload) => ({
  type: types.UNSOLICITED_LIST_SUCCESS,
  payload,
});
const UnsolicitedListFail = (error) => ({
  type: types.UNSOLICITED_LIST_FAIL,
  payload: error,
});
let url = process.env.REACT_APP_BASEURL;
const getCurrentPagination = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return {
    page: parseInt(searchParams.get("page")) || 1,
    pageSize: parseInt(searchParams.get("pageSize")) || 100,
  };
};

const isOnlySeasonFilter = (filterData) =>
  filterData?.seasonFilter?.length > 0 &&
  !filterData.searchFilter &&
  !filterData.colorFilter &&
  !filterData.sizeFilter &&
  !filterData.statusFilter &&
  !filterData.vendorFilter;

const hasMassFilterConditions = (filterData) =>
  filterData &&
  (filterData.searchFilter ||
    filterData.brandfilter ||
    filterData.colorfilter ||
    filterData.sizeFilter ||
    filterData.statusFilter ||
    filterData.vendorFilter ||
    filterData.seasonFilter);

export const expandAccordion = (payload) => ({
  type: types.EXPAND_ACCORDION,
  payload,
});
export const getSrtInitialList = (
  brand,
  style,
  factory,
  rejected_date,
  sale_sample,
  season,
  page,
  pageSize
) => {
  let secure_token = Cookies.get("access_token");
  const seasonArray = Array.isArray(season)
  ? season
  : season
  ? [season]
  : [];

const seasonParams = seasonArray.length
  ? seasonArray.map(s => `season=${encodeURIComponent(s)}`).join("&")
  : "";
  return function (dispatch) {
    const srtListConfig = {
      method: "GET",
      url: `srt/list?brand=${brand}&style=${style}&factory=${factory}&rejected_date=${rejected_date}&sale_sample=${sale_sample}&${seasonParams}&page=${page}&page_size=${pageSize}`,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(getSrtListLoading());
    client(srtListConfig)
      .then((resp) => {
        dispatch(getSrtListSuccess(resp.data));
        dispatch(resetSeasonFilter([]));
        dispatch(resetMassFilter([]));
        localStorage.setItem("srtApiData", resp.data);
      })
      .catch((error) => {
        dispatch(getSrtListFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        }
      });
  };
};
export const massSearchFilter = (
  searchfilter,
  brandfilter,
  colorfilter,
  sizefilter,
  statusfilter,
  vendorfilter,
  sale_samplefilter,
  seasonfilter,
  page,
  pageSize
) => {
  const secure_token = Cookies.get("access_token");
     const searchArray = Array.isArray(searchfilter)
    ? searchfilter
    : searchfilter
    ? searchfilter.split(",").map((s) => s.trim())
    : [];
  const seasonArray = Array.isArray(seasonfilter)
    ? seasonfilter
    : seasonfilter
    ? seasonfilter.split(",").map((s) => s.trim())
    : [];

  return function (dispatch) {
    const srtMassFilterConfig = {
      method: "POST",
      url: `style/mass_filter/?page=${page}&page_size=${pageSize}`,
      // searchfilter,
      data: {
        searchfilter: searchArray, // ✅ ARRAY payload
        brandfilter,
        colorfilter,
        sizefilter,
        statusfilter,
        vendorfilter,
        sale_samplefilter,
        seasonfilter: seasonArray ,
      },
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(massSearchFilterLoading());
    client(srtMassFilterConfig)
      .then((resp) => {
        dispatch(massSearchFilterSuccess(resp.data));
      })
      .catch((error) => {
        dispatch(massSearchFilterFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else toast.error("Data not found");
      });
  };
};
export const unsolicitedMassFilter = (
  searchfilter,
  factoryfilter,
  colorfilter,
  ref_no_filter,
  received_filter,
  sizefilter,
  page,
  pageSize
) => {
  const secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const unsolicitedSrtMassFilterConfig = {
      method: "GET",
      url: `unsolicited/mass/filter?searchfilter=${searchfilter}&factoryfilter=${factoryfilter}&colorfilter=${colorfilter}&ref_no_filter=${ref_no_filter}&received_filter=${received_filter}&sizefilter=${sizefilter}&page=${page}&page_size=${pageSize}`,
      searchfilter,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(unsolicitedMassSearchFilterLoading());
    client(unsolicitedSrtMassFilterConfig)
      .then((resp) => {
        dispatch(unsolicitedMassSearchFilterSuccess(resp.data));
        if (resp?.data?.length == 0) {
          toast.error("No Data found");
        }
      })
      .catch((error) => {
        dispatch(unsolicitedMassSearchFilterFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else toast.error("Data not found");
      });
  };
};
export const seasonSearchFilter = (brand, search, factory, sale_sample) => {
  const secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const srtSeasonFilterConfig = {
      method: "POST",
      url: `srt/search?brand=${brand}&search=${search}&factory=${factory}&sale_sample=${sale_sample}`,
      brand,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(seasonSearchFilterLoading());
    client(srtSeasonFilterConfig)
      .then((resp) => {
        dispatch(seasonSearchFilterSuccess(resp.data));
      })
      .catch((error) => {
        dispatch(seasonSearchFilterFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else toast.error("Data Not Found");
      });
  };
};
export const brandCommentSaver = (data, brandNameFromApi) => {
  const srtMassFilterData =
    JSON.parse(localStorage.getItem("srtMassData")) || {};
  const srtData = JSON.parse(localStorage.getItem("srtData")) || {};
  const seasonData = JSON.parse(localStorage.getItem("massFilterData")) || {};
  const secure_token = Cookies.get("access_token");

  return function (dispatch) {
    const { page, pageSize } = getCurrentPagination();
    const srtCmtConfig = {
      method: "POST",
      url: `srt/cmts`,
      data,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };

    dispatch(brandCommentSaverLoading());

    client(srtCmtConfig)
      .then((resp) => {
        if (!resp.data) throw new Error("No response data");

        dispatch(brandCommentSaverSuccess(resp.data));
        toast.success("Comment Saved");

        if (isOnlySeasonFilter(srtMassFilterData)) {
          dispatch(
            srtSeasonSearchFilter(
              srtMassFilterData?.brandfilter || brandNameFromApi || "",
              srtMassFilterData?.seasonFilter,
              page,
              pageSize,
              resp.data?.sale_sample || 0
            )
          );
        } else if (hasMassFilterConditions(srtMassFilterData)) {
          dispatch(
            massSearchFilter(
              srtMassFilterData.searchFilter || "",
              srtMassFilterData.brandfilter || "",
              srtMassFilterData.colorfilter || "",
              srtMassFilterData.sizeFilter || "",
              srtMassFilterData.statusFilter || "",
              srtMassFilterData.vendorFilter || "",
              resp.data?.sale_sample || "",
              srtMassFilterData.seasonFilter || "",
              page,
              pageSize
            )
          );
        } else {
          // Default to initial list with proper fallbacks
          dispatch(
            getSrtInitialList(
              srtData.brand || brandNameFromApi || "",
              srtData.style || "",
              srtData.factory || "",
              "",
              resp.data?.sale_sample || "",
              srtData.season || seasonData?.seasonFilter || "",
              page,
              pageSize
            )
          );
        }

        dispatch(resetMassFilter([]));
        dispatch(resetSeasonFilter([]));
      })
      .catch((error) => {
        console.error("Comment save error:", error);
        dispatch(brandCommentSaverFail(error));

        // Uncomment if you want error toasts
        // const errorMessage = error?.response?.data?.error || "Couldn't save the Comment";
        // toast.error(errorMessage);
      });
  };
};
export const designStatusSaver = (
  style,
  brand,
  factory,
  size,
  season,
  color_code,
  request_no,
  brand_status,
  design_status,
  pd_status,
  qa_status,
  sale_sample,
  user,
  brandNameFromApi
) => {
  // Add default empty objects when parsing localStorage
  const srtMassFilterData =
    JSON.parse(localStorage.getItem("srtMassData")) || {};
  const srtData = JSON.parse(localStorage.getItem("srtData")) || {};
  const seasonData = JSON.parse(localStorage.getItem("massFilterData")) || {};
  const secure_token = Cookies.get("access_token");

  return function (dispatch) {
    const { page, pageSize } = getCurrentPagination();
    const srtStatusConfig = {
      method: "POST",
      url: `style/srt_status_save/?style=${style}&brand=${brand}&factory=${factory}&size=${size}&season=${season}&color_code=${color_code}&request_no=${request_no}&brand_status=${brand_status}&design_status=${design_status}&pd_status=${pd_status}&qa_status=${qa_status}&sale_sample=${sale_sample}&user=${user}`,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };

    dispatch(designStatusSaverLoading());

    client(srtStatusConfig)
      .then((resp) => {
        if (!resp.data) throw new Error("No response data");

        dispatch(designStatusSaverSuccess(resp.data));
        const finalStatus =
          resp.data.status?.split("_").join(" ") || "Status updated";
        toast.success(finalStatus, { style: { maxWidth: 700 } });

        if (isOnlySeasonFilter(srtMassFilterData)) {
          dispatch(
            srtSeasonSearchFilter(
              srtMassFilterData?.brandfilter || brandNameFromApi || "",
              srtMassFilterData?.seasonFilter,
              page,
              pageSize,
              resp.data?.sale_sample || 0
            )
          );
        } else if (hasMassFilterConditions(srtMassFilterData)) {
          dispatch(
            massSearchFilter(
              srtMassFilterData.searchFilter || "",
              srtMassFilterData.brandfilter || "",
              srtMassFilterData.colorfilter || "",
              srtMassFilterData.sizeFilter || "",
              srtMassFilterData.statusFilter || "",
              srtMassFilterData.vendorFilter || "",
              resp.data?.sale_sample || "",
              srtMassFilterData.seasonFilter || "",
              page,
              pageSize
            )
          );
        } else {
          dispatch(
            getSrtInitialList(
              srtData.brand || brandNameFromApi || "",
              srtData.style || "",
              srtData.factory || "",
              "",
              resp.data?.sale_sample || "",
              srtData.season || seasonData?.seasonFilter || "",
              page,
              pageSize
            )
          );
        }
      })
      .catch((error) => {
        dispatch(designStatusSaverFail(error));

        // Uncomment if you want error toasts
        // const errorMessage = error?.response?.data?.error || error.message || "Couldn't save the Status";
        // toast.error(errorMessage);
      });
  };
};
export const srtDataSaver = (
  style,
  brand,
  factory,
  size,
  season,
  color_code,
  request_no,
  tracking_link,
  promised_date,
  received_date,
  qty_received,
  sale_sample,
  user,
  brandNameFromApi
) => {
  const srtMassFilterData =
    JSON.parse(localStorage.getItem("srtMassData")) || {}; // Add default empty object
  const seasonData = JSON.parse(localStorage.getItem("massFilterData")) || {};
  const srtData = JSON.parse(localStorage.getItem("srtData")) || {};
  const secure_token = Cookies.get("access_token");

  return function (dispatch) {
    const { page, pageSize } = getCurrentPagination();
    const srtDataSaverConfig = {
      method: "POST",
      url: `style/srt_save/?style=${style}&brand=${brand}&factory=${factory}&size=${size}&season=${season}&color_code=${color_code}&request_no=${request_no}&tracking_link=${tracking_link}&promised_date=${promised_date}&received_date=${received_date}&qty_received=${qty_received}&sale_sample=${sale_sample}&user=${user}`,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };

    dispatch(srtDataSaverLoading());

    client(srtDataSaverConfig)
      .then((resp) => {
        if (!resp.data) throw new Error("No data received");

        const finalArray = resp.data.status?.split("_").join(" ") || "Success";
        toast.success(finalArray, { style: { maxWidth: 720 } });
        dispatch(srtDataSaverSuccess(resp.data));

        if (isOnlySeasonFilter(srtMassFilterData)) {
          dispatch(
            srtSeasonSearchFilter(
              srtMassFilterData?.brandfilter || brandNameFromApi || "",
              srtMassFilterData?.seasonFilter,
              page,
              pageSize,
              resp.data?.sale_sample || 0
            )
          );
        } else if (hasMassFilterConditions(srtMassFilterData)) {
          dispatch(
            massSearchFilter(
              srtMassFilterData.searchFilter || "",
              srtMassFilterData.brandfilter || "",
              srtMassFilterData.colorfilter || "",
              srtMassFilterData.sizeFilter || "",
              srtMassFilterData.statusFilter || "",
              srtMassFilterData.vendorFilter || "",
              resp.data?.sale_sample || "",
              srtMassFilterData.seasonFilter || "",
              page,
              pageSize
            )
          );
        } else {
          // Only call getSrtInitialList if no mass filters are active
          dispatch(
            getSrtInitialList(
              brandNameFromApi || "",
              srtData.style || "",
              srtData.factory || "",
              "",
              resp.data?.sale_sample || "",
              srtData.season || seasonData?.seasonFilter || "",
              page,
              pageSize
            )
          );
        }
        // dispatch(resetMassFilter([]));
        // dispatch(resetSeasonFilter([]));
      })
      .catch((error) => {
        console.error("Data save error:", error);
        dispatch(srtDataSaverFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        }
        // Uncomment if you want to show error toasts
        // toast.error(error?.response?.data?.error || "Couldn't save the Data");
      });
  };
};
export const srtExport = (data) => {
  let secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const srtExportConfig = {
      method: "POST",
      url: `srt/export`,
      data,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
      responseType: "arraybuffer",
    };
    dispatch(srtExportLoading());
    client(srtExportConfig)
      .then((resp) => {
        dispatch(srtExportSuccess(resp.data));
        var blob = new Blob([resp.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var fileName = "SRT Export.xlsx";
        saveAs(blob, fileName);
      })
      .catch((error) => {
        dispatch(srtExportFail(error));

        if (error.response && error.response.data instanceof ArrayBuffer) {
          try {
            const decoder = new TextDecoder("utf-8");
            const text = decoder.decode(new Uint8Array(error.response.data));
            const json = JSON.parse(text);
            toast.error(json?.error || json?.message || "Export failed");
          } catch (e) {
            console.error("Error parsing backend response:", e);
            toast.error("Export failed. Please try again.");
          }
        } else if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else {
          toast.error("Export failed. Please try again.");
        }
      });
  };
};
export const srtReportGeneration = (factory, fromDate, toDate, season, brand) => {
  let secure_token = Cookies.get("access_token");
    const seasonArray = Array.isArray(season)
  ? season
  : season
  ? [season]
  : [];

const seasonParams = seasonArray.length
  ? seasonArray.map(s => `season=${encodeURIComponent(s)}`).join("&")
  : "";
  const factoryArray = Array.isArray(factory) ? factory : factory ? [factory] : [];
  const factoryParams = factoryArray
    .map(f => `factory=${encodeURIComponent(f)}`)
    .join("&");
  // No brand selected means no brand filter
  const brandArray = Array.isArray(brand) && brand.length ? brand : ["All"];
  const brandParams = brandArray
    .map(b => `brand=${encodeURIComponent(b)}`)
    .join("&");
  return function (dispatch) {
    const srtReportGenConfig = {
      method: "POST",
      url: `srt/report?${factoryParams}&from_date=${fromDate}&to_date=${toDate}&${seasonParams}&${brandParams}`,
      factory,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
      responseType: "arraybuffer",
    };
    dispatch(srtReportGenerationLoading());
    client(srtReportGenConfig)
      .then((resp) => {
        dispatch(srtReportGenerationSuccess(resp.data));
        var blob = new Blob([resp.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var fileName = "Srt Report.xlsx";
        saveAs(blob, fileName);
      })
      .catch((error) => {
        dispatch(srtReportGenerationFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else toast.error("Data Not Found");
      });
  };
};
export const CommentUpdate = (data, dataOfRow) => {
  const srtMassFilterData = JSON.parse(localStorage.getItem("srtMassData"));
  const srtData = JSON.parse(localStorage.getItem("srtData"));
  const seasonData = JSON.parse(localStorage.getItem("massFilterData"));
  const secure_token = Cookies.get("access_token");

  return function (dispatch) {
    const { page, pageSize } = getCurrentPagination();
    const srtCmtUpdateConfig = {
      method: "POST",
      url: `srt/cmts/update`,
      data,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };

    dispatch(srtCommentUpdateLoading());

    client(srtCmtUpdateConfig)
      .then((resp) => {
        toast.success("Comment Updated");
        dispatch(srtCommentUpdateSucces(resp.data));

        const hasMassFilterConditions = Object.entries(
          srtMassFilterData || {}
        ).some(
          ([_, value]) => typeof value === "string" && value.trim() !== ""
        );

        if (hasMassFilterConditions) {
          dispatch(
            massSearchFilter(
              srtMassFilterData?.searchFilter || "",
              srtMassFilterData?.brandfilter || "",
              srtMassFilterData?.colorfilter || "",
              srtMassFilterData?.sizefilter || "",
              srtMassFilterData?.statusFilter || "",
              srtMassFilterData?.vendorFilter || "",
              resp.data?.sale_sample,
              srtMassFilterData?.seasonFilter || "",
              page,
              pageSize
            )
          );
        } else {
          dispatch(
            getSrtInitialList(
              srtData?.brand || "",
              srtData?.style || "",
              srtData?.factory || "",
              "",
              resp.data?.sale_sample,
              srtData?.season || seasonData?.seasonFilter || "",
              page,
              pageSize
            )
          );
        }
      })
      .catch((error) => {
        dispatch(srtCommentUpdateFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else
          toast.error(
            error?.response?.data?.error || "Couldn't update the Comment"
          );
      });
  };
};
export const srtSearchFilter = (brand, navigate) => {
  window.open("/sample-receipt-tracker", "_blank");
  localStorage.setItem("activeKey", "3");
  if (
    brand == "DICKI" ||
    brand == "DICKC" ||
    brand == "DICKW" ||
    brand == "DICKG" ||
    brand == "DCKGW"
  ) {
    localStorage.setItem("srtActiveKey", "1");
    navigate("/sample-receipt-tracker/dickies-socks");
  } else if (brand == "SAUC") {
    localStorage.setItem("srtActiveKey", "2");
    navigate("/sample-receipt-tracker/saucony");
  } else if (brand == "EDBR") {
    localStorage.setItem("srtActiveKey", "3");
    navigate("/sample-receipt-tracker/eddie-bauer");
  } else if (brand == "PD") {
    localStorage.setItem("srtActiveKey", "4");
    navigate("/sample-receipt-tracker/pd");
  } else if (brand == "DCKGU" || brand == "DCKIU") {
    localStorage.setItem("srtActiveKey", "8");
    navigate("/sample-receipt-tracker/dickies-underwear");
  } else if (brand == "MFSM" || brand == "MFSW") {
    localStorage.setItem("srtActiveKey", "9");
    navigate("/sample-receipt-tracker/my-favorite-socks");
  } else if (brand == "NOST") {
    localStorage.setItem("srtActiveKey", "10");
    navigate("/sample-receipt-tracker/north-state");
  } else if (brand == "INFR") {
    localStorage.setItem("srtActiveKey", "11");
    navigate("/sample-receipt-tracker/inferno");
  } else if (brand == "TRUE") {
    localStorage.setItem("srtActiveKey", "12");
    navigate("/sample-receipt-tracker/true-energy", "_blank");
  } else if (brand == "NSTA") {
    localStorage.setItem("srtActiveKey", "13");
    navigate("/sample-receipt-tracker/north-state-apparel", "_blank");
  } else if (brand == "RDRY") {
    localStorage.setItem("srtActiveKey", "14");
    navigate("/sample-receipt-tracker/run-dry", "_blank");
  }
  else {
    localStorage.setItem("srtActiveKey", "1");
    navigate("/sample-receipt-tracker/dickies-socks");
  }
  // const secure_token = Cookies.get("access_token");
  // return function (dispatch) {
  //   const srtSearchFilterConfig = {
  //     method: "POST",
  //     url: `srt/search?brand=${brand}&search=${search}&factory=${factory}`,
  //     brand,
  //     headers: {
  //       Authorization: `Bearer ${secure_token}`,
  //     },
  //   };
  //   dispatch(srtSearchFilterLoading());
  //   client(srtSearchFilterConfig)
  //     .then((resp) => {
  //       dispatch(srtSearchFilterSuccess(resp.data));
  //     })
  //     .catch((error) => {
  //       dispatch(srtSearchFilterFail(error));
  //     });
  // };
};
export const srtSeasonSearchFilter = (
  brand,
  season,
  page,
  pageSize,
  sale_sample
) => {
  const secure_token = Cookies.get("access_token");
   const seasonQuery = Array.isArray(season) && season.length
    ? season.map(s => `season=${encodeURIComponent(s)}`).join("&")
    : `season=""`;
  console.log("seasonsssssss", season, seasonQuery)
  return function (dispatch) {
    const srtSeasonFilterConfig = {
      method: "GET",
      url: `srt/season_search?brand=${brand}&${seasonQuery}&page=${page}&page_size=${pageSize}&sale_sample=${sale_sample}`,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(srtSeasonSearchFilterLoading());
    client(srtSeasonFilterConfig)
      .then((resp) => {
        dispatch(srtSeasonSearchFilterSuccess(resp.data));
      })
      .catch((error) => {
        dispatch(srtSeasonSearchFilterFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        }
        // dispatch(
        //   getSrtInitialList(brand, "", "", "", sale_sample, season, 1, 10)
        // );
         else toast.error("Data not found");
      });
  };
};
export const srtBulkSave = (data, brandNameFromApi) => {
  const srtMassFilterData = JSON.parse(localStorage.getItem("srtMassData"));
  const srtData = JSON.parse(localStorage.getItem("srtData"));
  const secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const { page, pageSize } = getCurrentPagination();
    const srtBulkSaveConfig = {
      method: "POST",
      url: `style/srt_bulk_save/`,
      data,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(srtBulkSaveLoading());
    client(srtBulkSaveConfig)
      .then((resp) => {
        dispatch(srtBulkSaveSuccess(resp.data));
        const freshLocalData = JSON.parse(localStorage.getItem("srtMassData"));
        if (isOnlySeasonFilter(freshLocalData)) {
          dispatch(
            srtSeasonSearchFilter(
              freshLocalData?.brandfilter || brandNameFromApi,
              freshLocalData?.seasonFilter,
              page,
              pageSize,
              0
            )
          );
        } else if (srtMassFilterData) {
          dispatch(
            massSearchFilter(
              srtMassFilterData?.searchFilter
                ? srtMassFilterData?.searchFilter
                : "",
              srtMassFilterData?.brandfilter
                ? srtMassFilterData?.brandfilter
                : "",
              srtMassFilterData?.colorfilter
                ? srtMassFilterData?.colorfilter
                : "",
              srtMassFilterData?.sizeFilter
                ? srtMassFilterData?.sizeFilter
                : "",
              srtMassFilterData?.statusFilter
                ? srtMassFilterData?.statusFilter
                : "",
              srtMassFilterData?.vendorFilter
                ? srtMassFilterData?.vendorFilter
                : "",
              srtMassFilterData?.sale_samplefilter
                ? srtMassFilterData?.sale_samplefilter
                : 0,
              srtMassFilterData?.seasonFilter
                ? srtMassFilterData?.seasonFilter
                : "",
              page,
              pageSize
            )
          );
        } else {
          dispatch(
            getSrtInitialList(
              brandNameFromApi,
              srtData?.style || "",
              srtData?.factory || "",
              "",
              srtData?.sale_sample|| 0,
              srtData?.season|| "",
              page,
              pageSize
            )
          );
        }
        dispatch(resetMassFilter([]));
        dispatch(resetSeasonFilter([]));
      })
      .catch((error) => {
        dispatch(srtBulkSaveFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else
          toast.error(
            error?.response?.data?.error
              ? error?.response?.data?.error
              : "Could'nt Update Data"
          );
      });
  };
};
export const getSrtUnsolicitedSamplesList = (page, pageSize) => {
  let secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const srtUnsolicitedListConfig = {
      method: "GET",
      url: `unsolicited/samples/list?page=${page}&page_size=${pageSize}`,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(getSrtUnsolicitedListLoading());
    client(srtUnsolicitedListConfig)
      .then((resp) => {
        dispatch(getSrtUnsolicitedListSuccess(resp.data));
        dispatch(resetSeasonFilter([]));
        dispatch(resetMassFilter([]));
      })
      .catch((error) => {
        dispatch(getSrtUnsolicitedListFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        }
      });
  };
};
export const srtUnsolicitedBulkUploadSave = (data, brandNameFromApi) => {
  const srtMassFilterData = JSON.parse(localStorage.getItem("srtMassData"));
  const srtData = JSON.parse(localStorage.getItem("srtData"));
  const secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const { page, pageSize } = getCurrentPagination();

    const srtUnsolicitedBulkUploadConfig = {
      method: "POST",
      url: `unsolicited/samples/bulk/save`,
      data,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(srtUnsolicitedBulkUploadLoading());
    client(srtUnsolicitedBulkUploadConfig)
      .then((resp) => {
        dispatch(srtUnsolicitedBulkUploadSuccess(resp.data));
        toast.success("Unsolicited Samples are successfully saved");
        srtMassFilterData
          ? dispatch(
              massSearchFilter(
                srtMassFilterData?.searchFilter
                  ? srtMassFilterData?.searchFilter
                  : "",
                srtMassFilterData?.brandfilter
                  ? srtMassFilterData?.brandfilter
                  : "",
                srtMassFilterData?.colorfilter
                  ? srtMassFilterData?.colorfilter
                  : "",
                srtMassFilterData?.sizeFilter
                  ? srtMassFilterData?.sizeFilter
                  : "",
                srtMassFilterData?.statusFilter
                  ? srtMassFilterData?.statusFilter
                  : "",
                srtMassFilterData?.vendorFilter
                  ? srtMassFilterData?.vendorFilter
                  : "",
                srtMassFilterData?.sale_samplefilter
                  ? srtMassFilterData?.sale_samplefilter
                  : 0,
                srtMassFilterData?.seasonFilter
                  ? srtMassFilterData?.seasonFilter
                  : "",
                page,
                pageSize
              )
            )
          : dispatch(getSrtUnsolicitedSamplesList(page, pageSize));
        dispatch(resetMassFilter([]));
        dispatch(resetSeasonFilter([]));
      })
      .catch((error) => {
        dispatch(srtUnsolicitedBulkUploadFail(error));
        toast.error(
          error?.response?.data?.error
            ? error?.response?.data?.error
            : "Could'nt Update Data"
        );
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        }
      });
  };
};
export const srtUnsolicitedBulkExport = (data) => {
  let secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const srtUnsolicitedExportConfig = {
      method: "POST",
      url: `unsolicited/samples/export`,
      data,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
      responseType: "arraybuffer",
    };
    dispatch(srtUnsolicitedExportLoading());
    client(srtUnsolicitedExportConfig)
      .then((resp) => {
        dispatch(srtUnsolicitedExportSuccess(resp.data));
        var blob = new Blob([resp.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var fileName = "SRT Export.xlsx";
        saveAs(blob, fileName);
      })
      .catch((error) => {
        dispatch(srtUnsolicitedExportFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else toast.error("Please select the style to export");
      });
  };
};
export const srtUnsolicitedEditData = (data) => {
  let secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const { page, pageSize } = getCurrentPagination();

    const srtUnsolicitedData = {
      method: "POST",
      url: `unsolicited/samples/edit`,
      data,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
      responseType: "arraybuffer",
    };
    dispatch(srtUnsolicitedEditLoading());

    client(srtUnsolicitedData)
      .then((resp) => {
        dispatch(srtUnsolicitedEditSuccess(resp.data));
        // console.log("resp.data::",resp);
        dispatch(getSrtUnsolicitedSamplesList(page, pageSize));
        toast.success("Unsolicited Samples are successfully saved");
      })
      .catch((error) => {
        dispatch(srtUnsolicitedEditFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else toast.error("Couldn't Edit the data");
      });
  };
};
export const srtLogs = (
  style,
  factory,
  size,
  season,
  color,
  reqNo,
  saleSample
) => {
  let secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const srtLogConfig = {
      method: "GET",
      url: `/list/srt/logs?style=${style}&factory=${factory}&size=${size}&season=${season}&color_code=${color}&request_no=${reqNo}&sale_sample=${saleSample}`,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(srtLogsLoading());
    client(srtLogConfig)
      .then((resp) => {
        dispatch(srtLogsSuccess(resp.data));
      })
      .catch((error) => {
        dispatch(srtLogsFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        }
      });
  };
};
export const UnsolicitedList = () => {
  let secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const UnsolicitedConfig = {
      method: "GET",
      url: `/unsolicited/styles/list?page=null&page_size=null`,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(UnsolicitedListLoading());
    client(UnsolicitedConfig)
      .then((resp) => {
        dispatch(UnsolicitedListSuccess(resp.data));
      })
      .catch((error) => {
        dispatch(UnsolicitedListFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        }
      });
  };
};
